import { useNavigate } from 'react-router-dom';

export const InfoSection = ({
  className,
  title,
  editPath,
  items,
  'data-testid': testId,
}: {
  className: string;
  title: string;
  editPath: string;
  items: Array<{ field: string; value: string }>;
  'data-testid'?: string;
}) => {
  const navigate = useNavigate();

  return (
    <div className={className} data-testid={testId}>
      <div className="flex justify-between" data-testid="infoSection-header">
        <p className="font-sans md:text-center font-medium" data-testid="infoSection-title">{title}</p>
        <span 
          className="cursor-pointer" 
          onClick={() => navigate(editPath)}
          data-testid="infoSection-editButton"
        >
          Edit
        </span>
      </div>
      <div data-testid="infoSection-itemsList">
        {items.map((item, index) => (
          <div key={index} className="rounded-2xl px-5 py-3 bg-white mt-3" data-testid={`infoSection-item-${index}`}>
            <p className="typography-caption1 text-tertiary" data-testid={`infoSection-field-${index}`}>{item.field}</p>
            <p data-testid={`infoSection-value-${index}`}>{item.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
